<template>
    <div class="login auth-wrapper auth-v2">
      <b-row class="auth-inner m-0">

        <div class="brand-logo">
            <b-img
                fluid
                :src="logo"
                :alt="$t('common.login')"
            />
        </div>
        <!-- Left Text-->
        <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-5"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
              fluid
              :src="imgUrl"
              :alt="$t('common.login')"
            />
          </div>
        </b-col>
        <!-- /Left Text-->
  
        <!-- Login-->
        <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
        >
            <b-col
                sm="8"
                md="6"
                lg="12"
                class="px-xl-2 mx-auto"
            >
                <b-card-title
                    title-tag="h2"
                    class="font-weight-bold mb-1"
                >
                    {{ $t("common.signin") }}
                </b-card-title>
                <b-card-text class="mb-2">
                    {{ $t("common.signinText") }}
                </b-card-text>
    
                <!-- form -->
                <validation-observer ref="loginValidation">
                    <b-form
                        class="auth-login-form mt-2"
                        @submit.prevent
                    >
                        <!-- email -->
                        <b-form-group
                        :label="$t('common.email')"
                        label-for="login-email"
                        >
                        <validation-provider
                            #default="{ errors }"
                            :name="$t('common.email').toLowerCase()"
                            rules="required|email"
                        >
                            <b-form-input
                            id="login-email"
                            v-model="userEmail"
                            :state="errors.length > 0 ? false:null"
                            name="login-email"
                            placeholder="john@example.com"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        </b-form-group>
        
                        <!-- forgot password -->
                        <b-form-group>
                            <div class="d-flex justify-content-between">
                                <label for="login-password">{{ $t("common.password") }}</label>
                                <b-link :to="{name:'auth-forgot-password'}">
                                <small>{{ $t("common.forgetPassword") }}?</small>
                                </b-link>
                            </div>
                            <validation-provider
                                #default="{ errors }"
                                :name="$t('common.password').toLowerCase()"
                                rules="required"
                            >
                                <b-input-group
                                class="input-group-merge"
                                :class="errors.length > 0 ? 'is-invalid':null"
                                >
                                <b-form-input
                                    id="login-password"
                                    v-model="password"
                                    :state="errors.length > 0 ? false:null"
                                    class="form-control-merge"
                                    :type="passwordFieldType"
                                    name="login-password"
                                    placeholder="············"
                                />
                                <b-input-group-append is-text>
                                    <feather-icon
                                    class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"
                                    />
                                </b-input-group-append>
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
        
                        <!-- checkbox -->
                        <!-- <b-form-group>
                        <b-form-checkbox
                            id="remember-me"
                            v-model="status"
                            name="checkbox-1"
                        >
                            Remember Me
                        </b-form-checkbox>
                        </b-form-group> -->
        
                        <!-- submit buttons -->
                        <b-button
                            type="submit"
                            variant="primary"
                            block
                            @click="validationForm"
                        >
                            {{ $t("common.signin1") }}
                        </b-button>
                    </b-form>
                </validation-observer>
    
                <b-card-text class="text-center mt-2">
                <span>{{ $t("common.noAccount") }}</span>
                <b-link :to="{name:'auth-register'}">
                    <span>&nbsp;{{ $t("common.create") }}</span>
                </b-link>
                </b-card-text>

            </b-col>
        </b-col>
      <!-- /Login-->
      </b-row>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import store from '@/store/index'
import { required, email } from '@/@core/utils/validations/validations'
import { togglePasswordVisibility } from '@/@core/mixins/ui/forms'

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            // status: '',
            password: '',
            userEmail: '',
            sideImg: require('@/assets/images/pages/login-v2.svg'),
            // validation rulesimport store from '@/store/index'
            required,
            email,
            logo: require('@/assets/images/pages/logo.png')
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon'
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
                return this.sideImg
            }
            return this.sideImg
        },
        isLogin: function() {
            return this.$store.getters.isLogin;
        },
    },
    created() {
        if(this.$route.query.token) {
            this.$http.get(this.host + '/ico/password/confirm/' + this.$route.query.token)
            .then(response => {
                var res = response.body
                if (res.code === 0) {  
                    this.$toast.success(res.message);
                } else {
                    this.$toast.error(res.message);
                }
            })
        }
    },
    methods: {
        // init() {
        //     if (this.isLogin) {
        //         this.$router.push("/user");
        //         this.$toast.info(this.$t('common.alreadylogged'))
        //     }
        // },
        handleLogin() {
            const passwordEncoded = encodeURIComponent(this.password);
            this.$http.post(this.host + '/ico/login?email='+ this.userEmail +"&password="+ passwordEncoded)
            .then(async response => {
                var res = response.body;
                if (res.code == 0) {
                    localStorage.setItem("Email", res.data.email)
                    if(res.data.google2fa === 1) {
                        this.$router.push({name: 'auth-login-2fa'});
                    } else {
                        this.$store.commit("setMember", res.data)
                        await this.$store.dispatch("disconnect")
                        if( res.data.role === 0 ) {
                            this.$router.push("/admin");
                        } else if( res.data.role === 2 ) {
                            this.$router.push("/user");
                        }
                    }
                } else if ( res.code === 501 ) {
                    this.triggerOTP(res.data.email)
                    this.$toast.info(res.message);
                } else if ( res.code === 502 ) {
                    localStorage.setItem("email", res.data.email)
                    localStorage.setItem("text", res.message)
                    this.$router.push({name: 'auth-verify-email'})
                } 
                else {
                    this.$toast.error(res.message);
                }

            })
        },
        validationForm() {
            this.$refs.loginValidation.validate().then(success => {
                if (success) {
                    this.handleLogin()
                }
            })
        },
        triggerOTP(data) {
            var params = {
                email: data
            }
            this.$http.post(this.host + '/ico/send/email/otp', JSON.stringify(params))
            .then(response => {
                var res = response.body
                if(res.code === 0) {
                    localStorage.setItem("email",data)
                    this.$router.push({name: "auth-new-password", params: {data: data}});
                } else {
                    this.$toast.error(res.message)
                }
            })
        }
    },
}
</script>

<style lang="scss">
 @import '@/assets/scss/login.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue